export default "__VITE_ASSET__2fc5752f__"